import { IDataContextProvider } from "@refinedev/core/dist/contexts/data/IDataContext";
import { AxiosInstance } from "axios";
import axAPI from "../../../api/axios-instance";
import { DataProvider } from "@refinedev/core";
import dayjs from "dayjs";
import { dateFormat } from "helpers";

export const commentatorsDataProvider = (
  apiUrl: string,
  httpClient: AxiosInstance = axAPI
): DataProvider =>
  <IDataContextProvider>{
    getList: async ({ resource, sort, meta }) => {
      const url = "cms/commentators/get";

      try {
        const { data } = await httpClient.get(url);
        return {
          data: data,
          total: data.length,
        };
      } catch (e) {
        return Promise.reject(e);
      }
    },
    getOne: async ({ resource, id, meta }) => {
      const url = "cms/commentators/get";

      try {
        const { data: response } = await httpClient.get(url, {
          params: { id: id },
        });

        const commentator = Array.isArray(response)
          ? response.find((item: any) => item.id === id)
          : response;

        if (!commentator) {
          throw new Error(`Commentator with id ${id} not found`);
        }

        const data = {
          ...commentator,
          birthdate: commentator.birthdate && dayjs(commentator.birthdate),
        };

        return {
          data: data,
        };
      } catch (e) {
        return Promise.reject(e);
      }
    },
    create: async ({
      variables,
    }: {
      resource: string;
      meta?: any;
      variables: any;
    }) => {
      try {
        const { data } = await httpClient.post("cms/commentators/add", {
          firstName: variables.firstName,
          lastName: variables.lastName,
          patronymic: variables.patronymic,
          about: variables.about,
          socials: {
            VK: variables.vk_link,
            additionalProp2: variables.youtube_link,
            additionalProp3: variables.tg_link,
          },
          photo: variables.photo,
          birthdate: variables.birthdate
            ? dateFormat(variables.birthdate, "YYYY-MM-DDTHH:mm:ss")
            : null,
          city: variables.city,
          spec: variables.spec,
          voice: variables.voice,
        });

        return {
          data: {
            id: data.id || variables.id,
            ...variables,
          },
        };
      } catch (error: any) {
        return Promise.reject(error);
      }
    },
    update: async ({
      resource,
      id,
      meta,
      variables,
    }: {
      resource: string;
      id: number;
      meta?: any;
      variables: any;
    }) => {
      const url = "cms/commentators/set";

      try {
        const { data } = await httpClient.post(url, {
          id: id,
          firstName: variables.firstName,
          lastName: variables.lastName,
          patronymic: variables.patronymic,
          about: variables.about,
          socials: {
            VK: variables.vk_link,
            additionalProp2: variables.youtube_link,
            additionalProp3: variables.tg_link,
          },
          photo: variables.photo,
          birthdate: variables.birthdate
            ? dateFormat(variables.birthdate, "YYYY-MM-DDTHH:mm:ss")
            : null,
          city: variables.city,
          spec: variables.spec,
          voice: variables.voice,
        });

        return {
          data: {
            id: id,
            ...variables,
          },
        };
      } catch (error: any) {
        return Promise.reject(error);
      }
    },
    deleteOne: async ({
      resource,
      id,
      meta,
    }: {
      resource: string;
      id: number;
      meta?: any;
    }) => {
      try {
        const { data } = await httpClient.get("cms/commentators/remove", {
          params: { commentatorId: id },
        });

        return {
          data: { id: id },
        };
      } catch (error: any) {
        return Promise.reject(error);
      }
    },
    // Дополнительные методы для работы с матчами комментаторов
    custom: async ({
      url,
      method,
      filters,
      sort,
      payload,
      query,
      headers,
      meta,
    }) => {
      try {
        // Получение матчей комментатора
        if (meta?.action === "getMatches") {
          const { data } = await httpClient.get("cms/commentators/getMatch", {
            params: filters || {},
          });
          return {
            data: data,
            total: data.length,
          };
        }

        // Добавление матча комментатору
        if (meta?.action === "addMatch") {
          const { data } = await httpClient.post(
            "cms/commentators/addMatch",
            payload
          );
          return {
            data: data,
          };
        }
        throw new Error("Unknown custom action");
      } catch (e) {
        return Promise.reject(e);
      }
    },
  };
